import "./Products.module.css";
import Header from "@/reusable_sections/Header";
import ProductCategories from "./sections/ProductCategories";
import ProductListing from "./sections/ProductListing";
import RequestAQuote from "./sections/RequestAQuote";
import Footer from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <Header />
      <ProductCategories />
      <ProductListing />
      <RequestAQuote />
      <Footer />
    </div>;
}